module.exports = __webpack_public_path__ + "static/media/perfil_usuario.4419274a.svg";